export const Routes = {
  LOGIN: "/",
  EDITOR: "/editor",
  HOME: "/home",
  MATERIA: "/materia",
  PRODUCAO: "/producao",
  ARTIGOS: "/artigos",
  REGISTER: "/cadastro",
  PERFIL: "/perfil"
};
